import { ColumnTypeEnum } from 'common/components/entities/Column/enums/ColumnTypeEnum'
import { ColumnInterface } from 'common/components/entities/Column/types/ColumnInterface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { createRowColumnLayout } from '../entities/row/create-row-column-layout'
import { createSection } from '../entities/section/create-section'
import { insertChild } from '../entities/utils/generate-base-entity'
import {
  RootEntityInterface,
  WithChildIdsInterface,
} from '../types/base-entity-interface'
import { PageContentEntities } from '../types/page-interface'

const createSectionLayout = (
  rootEntity: RootEntityInterface,
  position: number,
  columnType?: ColumnTypeEnum,
) => {
  const section = createSection(rootEntity.id)
  const layout = createRowColumnLayout({
    parentEntity: section,
    position,
    columnType,
  })

  return {
    column: layout.column1,
    structure: {
      [rootEntity.id]: {
        ...rootEntity,
        childIds: insertChild(rootEntity.childIds, section.id, position),
      },
      ...layout.structure,
    },
  }
}

export const createBaseStructure = (
  containerEntity: WithChildIdsInterface,
  position: number,
  columnType?: ColumnTypeEnum,
) => {
  let structure: PageContentEntities
  let descendantEntity: ColumnInterface
  // we might improve it by using more general checks, but know it can be brittle
  switch (containerEntity.type) {
    case EntityTypeEnum.Body:
    case EntityTypeEnum.BlogPostLayoutBody:
    case EntityTypeEnum.BlogPageBody:
    case EntityTypeEnum.BlogPostBody:
    case EntityTypeEnum.WebsiteLayoutBody:
    case EntityTypeEnum.WebsitePageBody: {
      const layout = createSectionLayout(containerEntity, position, columnType)
      descendantEntity = layout.column
      structure = layout.structure as PageContentEntities
      break
    }
    default: {
      const layout = createRowColumnLayout({
        parentEntity: containerEntity,
        position,
        columnType,
      })
      descendantEntity = layout.column1
      structure = layout.structure as PageContentEntities
      break
    }
  }

  return { structure, descendantEntity }
}
